import { render } from "./WelcomeEligible.vue?vue&type=template&id=5f2f0c56"
import script from "./WelcomeEligible.vue?vue&type=script&lang=js"
export * from "./WelcomeEligible.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__